const fetchSingleBlog = async (slug) => {
  const query = encodeURIComponent(`
  *[_type == "blog" && slug.current == "${slug}"][0]{
    title,
    slug,
    body,
    category,
    author,
    publishedAt,
    "mainImageUrl": mainImage.asset->url,

    // Related categories
    categories[]->{
      title,
      slug
    },

    // SEO Fields
    seoTitle,
    metaDescription,
    keywords,
    "socialShareImageUrl": socialShareImage,
    "appleTouchIconUrl": appleTouchIcon,
    canonicalUrl
  }
`);

  const url = `https://4afi23a8.api.sanity.io/v1/data/query/production?query=${query}`;

  const res = await fetch(url);

  if (!res.ok) {
    throw new Error("Failed to fetch blog post");
  }

  const { result } = await res.json();
  return result;
};

export default fetchSingleBlog;
